import React from 'react';
import { motion } from 'framer-motion';
import { BackgroundPattern } from './BackgroundPattern';
import { AnimatedText } from './AnimatedText';
export function HeroSection() {
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault();
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="home" className="relative bg-gradient-to-r from-blue-900 to-blue-700 py-28 md:py-40 overflow-hidden" data-id="element-201">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1497366811353-6870744d04b2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')] bg-cover bg-center opacity-20" data-id="element-202"></div>
      <motion.div className="absolute top-0 left-0 w-64 h-64 opacity-20 -translate-x-1/4 -translate-y-1/4" initial={{
      opacity: 0,
      rotate: -10
    }} animate={{
      opacity: 0.2,
      rotate: 0
    }} transition={{
      duration: 1.5,
      delay: 0.5
    }} data-id="element-203">
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="text-green-500 fill-current" data-id="element-204">
          <path d="M44.3,-76.4C58.4,-70.3,71.5,-60.2,79.9,-46.7C88.3,-33.1,92,-16.6,90.5,-1C89,14.5,82.3,29.1,73.7,42.1C65.1,55.1,54.7,66.6,41.8,73.5C28.9,80.5,14.5,83,0.5,82.2C-13.5,81.4,-27,77.2,-39.8,70.4C-52.6,63.6,-64.8,54.1,-73.5,41.8C-82.3,29.4,-87.7,14.7,-87.1,0.3C-86.6,-14,-80,-28,-71.7,-40.3C-63.4,-52.5,-53.2,-63,-41,-70.4C-28.9,-77.8,-14.5,-82.1,0.7,-83.3C15.8,-84.4,31.7,-82.5,44.3,-76.4Z" transform="translate(100 100)" data-id="element-205" />
        </svg>
      </motion.div>
      <motion.div className="absolute bottom-0 right-0 w-80 h-80 opacity-15 translate-x-1/4 translate-y-1/4" initial={{
      opacity: 0,
      rotate: 10
    }} animate={{
      opacity: 0.15,
      rotate: 0
    }} transition={{
      duration: 1.5,
      delay: 0.8
    }} data-id="element-206">
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="text-green-600 fill-current" data-id="element-207">
          <path d="M45.3,-76.3C59.9,-69.1,73.8,-59.4,83.1,-46.2C92.4,-32.9,97.2,-16.5,96.6,-0.3C96,15.8,90,31.6,80.5,44.8C71,58,58.1,68.5,43.7,75.6C29.3,82.7,13.3,86.3,-2,87.2C-17.3,88.1,-34.6,86.2,-49.5,79C-64.4,71.8,-76.9,59.3,-84.6,44.5C-92.3,29.7,-95.2,12.4,-93.8,-4.3C-92.5,-20.9,-86.8,-37,-76.8,-49.6C-66.9,-62.2,-52.7,-71.3,-38.2,-78.4C-23.7,-85.5,-8.9,-90.6,4,-95.3C16.8,-100,33.6,-102.4,45.3,-96.5C57,-90.7,63.6,-76.5,45.3,-76.3Z" transform="translate(100 100)" data-id="element-208" />
        </svg>
      </motion.div>
      <motion.div className="absolute top-1/2 right-10 w-40 h-40 opacity-20 hidden lg:block" initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 0.2,
      y: 0
    }} transition={{
      duration: 1.2,
      delay: 1
    }} data-id="element-209">
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="text-green-400 fill-current" data-id="element-210">
          <path d="M37.9,-65.3C50.4,-59.2,62.8,-51.1,71.3,-39.5C79.9,-27.9,84.5,-13.9,84.5,-0.1C84.4,13.8,79.6,27.6,71.4,39C63.2,50.4,51.5,59.4,38.6,65.9C25.7,72.3,11.6,76.2,-1.2,78C-14,79.7,-28.1,79.3,-41.3,74.2C-54.5,69.1,-66.8,59.3,-74.6,46.4C-82.3,33.5,-85.6,16.7,-85.2,0.2C-84.8,-16.3,-80.8,-32.6,-72.4,-45.8C-64,-59,-51.3,-69.1,-37.6,-74.4C-23.8,-79.6,-9.4,-79.9,2.3,-83.8C14,-87.8,28,-90.4,37.9,-84.6C47.9,-78.8,53.8,-64.5,37.9,-65.3Z" transform="translate(100 100)" data-id="element-211" />
        </svg>
      </motion.div>
      <BackgroundPattern className="text-white" data-id="element-212" />
      <div className="container mx-auto px-6 relative z-10" data-id="element-213">
        <div className="max-w-3xl mx-auto md:mx-0" data-id="element-214">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8
        }} data-id="element-215">
            <AnimatedText text="Building Excellence Across Industries" className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8" as="h1" data-id="element-216" />
          </motion.div>
          <motion.p className="text-xl md:text-2xl text-white/90 mb-10" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} data-id="element-217">
            Solochus Group: A diverse portfolio of businesses delivering
            exceptional value in hospitality, retail, manufacturing, and food
            services.
          </motion.p>
          <motion.div className="flex flex-wrap gap-5" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.8
        }} data-id="element-218">
            <motion.a href="#subsidiaries" className="px-8 py-4 bg-white text-blue-700 font-medium rounded-md hover:bg-blue-50 transition-colors" onClick={e => scrollToSection(e, 'subsidiaries')} whileHover={{
            scale: 1.05,
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
          }} whileTap={{
            scale: 0.98
          }} data-id="element-219">
              Explore Our Companies
            </motion.a>
            <motion.a href="#contact" className="px-8 py-4 bg-transparent border-2 border-white text-white font-medium rounded-md hover:bg-white/10 transition-colors" onClick={e => scrollToSection(e, 'contact')} whileHover={{
            scale: 1.05,
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
          }} whileTap={{
            scale: 0.98
          }} data-id="element-220">
              Contact Us
            </motion.a>
          </motion.div>
        </div>
      </div>
      <motion.div className="absolute left-1/4 bottom-20 w-6 h-6 text-green-400" initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: [0, 1, 1, 0],
      y: [20, -20, -60, -100],
      x: [0, 10, 0, -10],
      rotate: [0, 10, 0, -10]
    }} transition={{
      duration: 8,
      repeat: Infinity,
      repeatType: 'loop',
      times: [0, 0.3, 0.7, 1]
    }} data-id="element-221">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" data-id="element-222">
          <path d="M12 2c-3.309 0-6 2.691-6 6 0 3.855 4.386 9.312 5.58 10.824.278.355.842.355 1.12 0C13.894 17.312 18 11.855 18 8c0-3.309-2.691-6-6-6z" data-id="element-223" />
        </svg>
      </motion.div>
      <motion.div className="absolute right-1/3 bottom-32 w-4 h-4 text-green-500" initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: [0, 1, 1, 0],
      y: [20, -20, -60, -100],
      x: [0, -10, 0, 10],
      rotate: [0, -10, 0, 10]
    }} transition={{
      duration: 10,
      repeat: Infinity,
      repeatType: 'loop',
      times: [0, 0.3, 0.7, 1],
      delay: 2
    }} data-id="element-224">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" data-id="element-225">
          <path d="M12 2c-3.309 0-6 2.691-6 6 0 3.855 4.386 9.312 5.58 10.824.278.355.842.355 1.12 0C13.894 17.312 18 11.855 18 8c0-3.309-2.691-6-6-6z" data-id="element-226" />
        </svg>
      </motion.div>
      <motion.div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1.5,
      delay: 1.2
    }} data-id="element-227" />
    </section>;
}